export default [
    {
        title: 'Inicio',
        icon: 'HomeIcon',
        route: 'dashboard',
        permission: 'Dashboard',
        tagVariant: 'light-warning',
    },
]
